import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { roleCanAccessPath } from 'core/constants/routes-by-role';
import { AuthSessionService } from 'core/services/auth-session.service';

/**
 * Bloqueia deep links fora da área do perfil (nav ≠ autorização).
 * Usa o mapa em `routes-by-role.ts`.
 */
export const roleGuard: CanActivateFn = (_route, state) => {
  const auth = inject(AuthSessionService);
  const router = inject(Router);
  const role = auth.role();

  if (roleCanAccessPath(role, state.url)) {
    return true;
  }

  return router.createUrlTree(['/']);
};
